import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider'

(() => {

    const SLIDERS = Array.from(document.querySelectorAll('.offset-slider-wrapper'))

    if(!SLIDERS) return

    const STYLE = getComputedStyle(document.documentElement)
    const xs = parseInt(STYLE.getPropertyValue('--break-xs'))
    const sm = parseInt(STYLE.getPropertyValue('--break-sm'))
    const md = parseInt(STYLE.getPropertyValue('--break-md'))

    SLIDERS.forEach(slider => {

        const responsive = {}
        responsive[xs] = { items: 3 }
        responsive[sm] = { items: 4 }
        responsive[md] = { items: 5 }

        const TNS = tns({
            container: slider,
            controlsContainer: document.querySelector('.offset-slider--navigation'),
            autoplay: true,
            autoplayHoverPause: true,
            autoplayButtonOutput: false,
            items: 1,
            gutter: 20,
            responsive
        })

    })

})()

